export default "__VITE_ASSET__9db22795__"